export default __webpack_public_path__ + "static/media/cb1.8bd077aa.svg";